import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Deal } from 'utils/types';

import c from '../utils/constants';

interface Payload {
  dealIds: string[];
  stageId: string;
  pipelineId: string;
}

export default function useMoveDeals() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();

  const args = state;

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const api = new Api(args);

      const data = await api.patch(
        await withAcl({
          account: {
            url: `/api/v1/sales/deals/move`,
            payload,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/sales/deals/move`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: (successData: { data: Deal; message: string }) => {
      queryClient.invalidateQueries([c.PIPELINES]);
      toastSuccess(successData.message);
    },
  });
}
